import { WorkorderDeclinedMpviCode } from '@quorum/models/xs-resource';
import { WorkorderDeclinedMpviCodeQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum WorkOrderDeclinedOperationsEntityActionTypes {
  GetWorkOrderDeclinedOperationsFromServer = '[Fixed Operations] Get Work Order Declined Operations From Server',
  GetWorkOrderDeclinedOperationsFromServerError = '[Fixed Operations] Get Work Order Declined Operations From Server Error',
  GetWorkOrderDeclinedOperationsFromServerSuccess = '[Fixed Operations] Get Work Order Declined Operations From Server Success',
  CreateWorkOrderDeclinedOperationsOnServer = '[Fixed Operations] Create Work Order Declined Operations On Server',
  CreateWorkOrderDeclinedOperationsOnServerError = '[Fixed Operations] Create Work Order Declined Operations On Server Error',
  CreateWorkOrderDeclinedOperationsOnServerSuccess = '[Fixed Operations] Create Work Order Declined Operations On Server Success',
  DeleteWorkOrderDeclinedOperationFromServer = '[Fixed Operations] Delete Work Order Declined Operation From Server',
  DeleteWorkOrderDeclinedOperationFromServerError = '[Fixed Operations] Delete Work Order Declined Operation From Server Error',
  DeleteWorkOrderDeclinedOperationFromServerSuccess = '[Fixed Operations] Delete Work Order Declined Operation From Server Success',
  UpdateWorkOrderDeclinedOperationOnServer = '[Fixed Operations] Update Work Order Declined Operation On Server',
  UpdateWorkOrderDeclinedOperationOnServerError = '[Fixed Operations] Update Work Order Declined Operation On Server Error',
  UpdateWorkOrderDeclinedOperationOnServerSuccess = '[Fixed Operations] Update Work Order Declined Operation On Server Success',
}

export class GetWorkOrderDeclinedOperationsFromServer implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.GetWorkOrderDeclinedOperationsFromServer;
  constructor(public payload: WorkorderDeclinedMpviCodeQueryParameters) {}
}
export class GetWorkOrderDeclinedOperationsFromServerError implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.GetWorkOrderDeclinedOperationsFromServerError;
  constructor(public payload: any) {}
}
export class GetWorkOrderDeclinedOperationsFromServerSuccess implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.GetWorkOrderDeclinedOperationsFromServerSuccess;
  constructor(public payload: WorkorderDeclinedMpviCode[]) {}
}

export class CreateWorkOrderDeclinedOperationsOnServer implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.CreateWorkOrderDeclinedOperationsOnServer;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}
export class CreateWorkOrderDeclinedOperationsOnServerError implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.CreateWorkOrderDeclinedOperationsOnServerError;
  constructor(public payload: any) {}
}
export class CreateWorkOrderDeclinedOperationsOnServerSuccess implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.CreateWorkOrderDeclinedOperationsOnServerSuccess;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}

export class DeleteWorkOrderDeclinedOperationFromServer implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.DeleteWorkOrderDeclinedOperationFromServer;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}
export class DeleteWorkOrderDeclinedOperationFromServerError implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.DeleteWorkOrderDeclinedOperationFromServerError;
  constructor(public payload: any) {}
}
export class DeleteWorkOrderDeclinedOperationFromServerSuccess implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.DeleteWorkOrderDeclinedOperationFromServerSuccess;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}

export class UpdateWorkOrderDeclinedOperationOnServer implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.UpdateWorkOrderDeclinedOperationOnServer;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}
export class UpdateWorkOrderDeclinedOperationOnServerError implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.UpdateWorkOrderDeclinedOperationOnServerError;
  constructor(public payload: any) {}
}
export class UpdateWorkOrderDeclinedOperationOnServerSuccess implements Action {
  readonly type = WorkOrderDeclinedOperationsEntityActionTypes.UpdateWorkOrderDeclinedOperationOnServerSuccess;
  constructor(public payload: WorkorderDeclinedMpviCode) {}
}

export type WorkOrderDeclinedOperationsEntityAction =
  | GetWorkOrderDeclinedOperationsFromServer
  | GetWorkOrderDeclinedOperationsFromServerError
  | GetWorkOrderDeclinedOperationsFromServerSuccess
  | CreateWorkOrderDeclinedOperationsOnServer
  | CreateWorkOrderDeclinedOperationsOnServerError
  | CreateWorkOrderDeclinedOperationsOnServerSuccess
  | DeleteWorkOrderDeclinedOperationFromServer
  | DeleteWorkOrderDeclinedOperationFromServerError
  | DeleteWorkOrderDeclinedOperationFromServerSuccess
  | UpdateWorkOrderDeclinedOperationOnServer
  | UpdateWorkOrderDeclinedOperationOnServerError
  | UpdateWorkOrderDeclinedOperationOnServerSuccess;

export const fromWorkOrderDeclinedOperationsEntityActions = {
  GetWorkOrderDeclinedOperationsFromServer,
  GetWorkOrderDeclinedOperationsFromServerError,
  GetWorkOrderDeclinedOperationsFromServerSuccess,
  CreateWorkOrderDeclinedOperationsOnServer,
  CreateWorkOrderDeclinedOperationsOnServerError,
  CreateWorkOrderDeclinedOperationsOnServerSuccess,
  DeleteWorkOrderDeclinedOperationFromServer,
  DeleteWorkOrderDeclinedOperationFromServerError,
  DeleteWorkOrderDeclinedOperationFromServerSuccess,
  UpdateWorkOrderDeclinedOperationOnServer,
  UpdateWorkOrderDeclinedOperationOnServerError,
  UpdateWorkOrderDeclinedOperationOnServerSuccess,
};
